import { request } from '../utils/request';

const LIKE_TYPE = 'EVENT';

/**
 * Get like count for an event (public, no auth required).
 * @param {string|number} eventId
 * @returns {Promise<number>}
 */
export function getLikeCount(eventId) {
  return request(
    `/api/likes/count?likeType=${LIKE_TYPE}&likeItem=${encodeURIComponent(eventId)}`
  );
}

/**
 * Get like state for an event (requires auth).
 * Returns { likeType, likeItem, liked, likeCount }.
 * @param {string|number} eventId
 * @returns {Promise<{liked: boolean, likeCount: number}>}
 */
export function getLikeState(eventId) {
  return request(
    `/api/likes/state?likeType=${LIKE_TYPE}&likeItem=${encodeURIComponent(eventId)}`
  );
}

/**
 * Like an event (requires auth).
 * @param {string|number} eventId
 * @returns {Promise<{liked: boolean, likeCount: number}>}
 */
export function likeEvent(eventId) {
  return request('/api/likes', {
    method: 'POST',
    body: JSON.stringify({ likeType: LIKE_TYPE, likeItem: String(eventId) }),
  });
}

/**
 * Unlike an event (requires auth).
 * @param {string|number} eventId
 * @returns {Promise<{liked: boolean, likeCount: number}>}
 */
export function unlikeEvent(eventId) {
  return request('/api/likes', {
    method: 'DELETE',
    body: JSON.stringify({ likeType: LIKE_TYPE, likeItem: String(eventId) }),
  });
}
